import { RouterModule, Routes } from '@angular/router';
import { NotAuthorizedComponent } from './security/not-authorized/not-authorized.component';
import { canActivateLogin } from './security/login.guard';
import { AppDeciderComponent } from './layouts/app-decider/app-decider.component';
import { LogoutComponent } from './security/logout/logout.component';
import { GwrRoutes } from './gwr/gwr.routes';
import { DashboardRoutes } from './dashboard/dashboard.routes';
import { GrundstueckRoutes } from './grundstueck/grundstueck.routes';
import { ICPRoutes } from './icp/icp.routes';
import { GrundbuchRoutes } from './grundbuch/grundbuch.routes';
import { VermessungRoutes } from './vermessung/vermessung.routes';
import { StammdatenRoutes } from './stammdaten/stammdaten.routes';
import { NeskoabRoutes } from './neskoab/neskoab.routes';
import { SystemRoutes } from './system/system.routes';
import { SecurityRoutes } from './security/security.routes';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NotFoundComponent } from './security/not-found/not-found.component';
import { InvalidRequestComponent } from './security/invalid-request/invalidrequest.component';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { IntercapiLayoutComponent } from './layouts/intercapi-layout/intercapi-layout.component';
import { IntercapiPublicLayoutComponent } from './layouts/intercapi-public-layout/intercapi-public-layout.component';
import { PublikationenPublicLayoutComponent } from './layouts/publikationen-public-layout/publikationen-public-layout.component';
import { EnvironmentMarkerComponent } from './layouts/environment-marker/environment-marker.component';
import { AppFormatConfigService } from './core/services/app-format-config.service';
import { NeskoabViewmodelService } from './neskoab/neskoab-viewmodel.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home/dashboard',
    pathMatch: 'prefix'
  },
  {
    path: 'unauthorized',
    component: NotAuthorizedComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  ...DashboardRoutes,
  ...GrundstueckRoutes,
  ...ICPRoutes,
  ...GrundbuchRoutes,
  ...VermessungRoutes,
  ...GwrRoutes,
  ...StammdatenRoutes,
  ...NeskoabRoutes,
  ...SystemRoutes,
  {
    path: 'unterstuetzung',
    component: AppDeciderComponent,
    canActivate: [canActivateLogin]
  },
  ...SecurityRoutes,
  {
    path: '**',
    redirectTo: 'home/dashboard',
    pathMatch: 'prefix'
  }
];

@NgModule({
  imports: [
    BrowserModule,
    SharedModule,
    CoreModule,
    RouterModule,
    LoadingBarRouterModule,
    IntercapiLayoutComponent,
    IntercapiPublicLayoutComponent,
    AppDeciderComponent,
    PublikationenPublicLayoutComponent,
    NotAuthorizedComponent,
    EnvironmentMarkerComponent,
    NotFoundComponent,
    InvalidRequestComponent
  ],
  exports: [RouterModule],
  providers: [AppFormatConfigService, NeskoabViewmodelService]
})
export class AppRoutingModule {
  static forRoot(): ModuleWithProviders<AppRoutingModuleForRoot> {
    return {
      ngModule: AppRoutingModuleForRoot
    };
  }
}

@NgModule({
  imports: [
    AppRoutingModule,
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload'
    }),
    CoreModule.forRoot()
  ],
  exports: [AppRoutingModule]
})
export class AppRoutingModuleForRoot {}
